/**
 *
 * @module entry
 * @desc {SDK.Services.Media.AdEngine} entry point.
 *
 */

import AdEngineClient from './adEngineClient';
import AdEngineClientConfiguration from './adEngineClientConfiguration';
import AdEngineClientEndpoint from './adEngineClientEndpoint';

/**
 *
 * @typedef SDK.Services.Media.AdEngine
 * @type {Object}
 *
 * @property {AdEngineClient} AdEngineClient
 * @property {AdEngineClientConfiguration} AdEngineClientConfiguration
 * @property {AdEngineClientEndpoint} AdEngineClientEndpoint
 *
 */

/**
 *
 * @type {SDK.Services.Media.AdEngine}
 *
 */
export default {

    AdEngineClient,
    AdEngineClientConfiguration,
    AdEngineClientEndpoint

};



// WEBPACK FOOTER //
// ./src/services/media/adEngine/entry.js